import { ActivatedRoute, Router } from '@angular/router';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { Inject, Injectable, NgZone, OnInit } from '@angular/core';

import { SecurityService } from './security.service';
import jwt_decode from 'jwt-decode';

// import { environment } from 'src/environments/environment';

// import { environment } from '../environment';

@Injectable({
  providedIn: 'root',
})

export class MainService implements OnInit {
  production: any;
  apiHost: any;
  apiPort: any;
  apiHostDd: any;
  apiPortDd: any;
  socketPort: any;
  loginWithPassword: any;
  httpUrl: any;
  httpUrlDd: any;
  hostWithReturnUrl: any
  urlPassAcctID: any;
  urlPassReturnfpath: any;
  constructor(
    private http: HttpClient,
    private router: Router,
    private route: ActivatedRoute,
    public zone: NgZone


  ) {



  }
  ngOnInit(): void {

  }
  loginflag = false;
  logoutflag = false;
  b_acct_id: any;
  allAccounts = [];
  componentCode = {};
  selectedAccount = null;
  otp_flag = false;
  ipAddress: any;
  browser: any;
  date: any;
  lat: any;
  lng: any;
  zoom: any;
  session_id: any;
  loginpass_flag = false;
  verfiy_token_obj = { authtoken: '' };
  solnHostUrl: any;
  pubHostUrl: any;
  hostWithReturnUrls = [];
  currentOrigin: any;
  fpath: any;
  selectedaccount: any;
  login = {}
  audit_info_obj = {}
  product_cd: [] | any;
  auth_validation = {}
  accountlist: Array<any> = [];
  async getAllEnvConfig(object: {
    apiHost: string;
    apiPort: number;
    apiHostDd: string;
    apiPortDd: number;
    loginWithPassword: boolean;
    hostApp: any
    auth_validation: any
  }) {
    this.apiHost = object.apiHost;
    this.apiPort = object.apiPort;
    this.apiHostDd = object.apiHostDd;
    this.apiPortDd = object.apiPortDd;
    this.loginWithPassword = object.loginWithPassword;
    this.hostWithReturnUrl = object.hostApp;
    this.auth_validation = object.auth_validation
    console.log(this.hostWithReturnUrl, ' this.hostWithReturnUrl')
    this.httpUrl = this.apiHost + ':' + this.apiPort;
    console.log('SECURITY-API @ ' + this.httpUrl + ' is being used.');
    this.httpUrlDd = this.apiHostDd + ':' + this.apiPortDd;
    console.log('DD - ' + this.httpUrlDd);
  }

  async getRetuenUrlWithAcctID(returnUrl: String) {
    // console.log('Url pass acct ID:', acct);

    //this.urlPassAcctID = acct;
    this.urlPassReturnfpath = returnUrl;

  }


  async getCurrentLegalEntity(party: any) {
    const resp = await this.http
      .get<any>(
        this.httpUrl + '/systemdata/legalentity/getcurrentlegalentity' + party
      )
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;
  }
  validatePhoneNumber(input_str: any) {
    var re = /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im;
    return re.test(input_str);
  }
  validateEmail(input_str: any) {
    var re =
      /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/im;
    return re.test(input_str);
  }
  //////////////////////////////Login logic/////////////////
  fpath_withAcct = ''
  async getHostFpath() {
    this.currentOrigin = location.protocol + '//' + location.hostname;
    console.log(this.hostWithReturnUrl, this.currentOrigin)
    for (const hostapp of this.hostWithReturnUrl) {
      if (hostapp['name'] == 'solnAdmin') {
        this.solnHostUrl = hostapp['host'];
      }
      if (hostapp['name'] == 'erppublic') {
        this.pubHostUrl = hostapp['host'];
      }
      if (this.currentOrigin == hostapp['host']) {
        console.log('there it is');

        this.fpath = hostapp['fpath_noAcct'];
        this.fpath_withAcct = hostapp?.['fpath_withAcct']
      }

    }
  }









  //employee related role data

  //user system details insert
  async audit_insert(audit_info_obj: any) {
    var resp = await this.createloginInfo(audit_info_obj);
  }
  assigned_user_modules = []
  jwtToken: any;

  //final submit
  async finalSubmit(erpUser) {
    // let erpUser = JSON.parse(sessionStorage.getItem('erpUser'));
    // console.log(this.selectedaccount);
    // erpUser['account_name'] = this.selectedaccount?.['account_name'];
    // erpUser['account_short_name'] = this.selectedaccount?.['account_short_name'];
    // erpUser['acct_desc'] = this.selectedaccount?.['acct_desc'];
    // erpUser['address'] = this.selectedaccount?.['address'];
    // erpUser['arr_id'] = this.selectedaccount?.['arr_id'];
    // erpUser['b_acct_id'] = 1*(this.selectedaccount?.['b_acct_id']);
    // erpUser['role_cd'] = this.assigned_User_Roles;
    // erpUser['assigned_product_cd'] = this.product_cd;
    // erpUser['module_cd'] = this.product_cd;
    // erpUser['user_id'] = this.selectedaccount.le_id;
    // erpUser['isAuthorised'] = true;
    // erpUser['assigned_component'] = await this.getAllAssignedComponent(
    //   this.b_acct_id,
    //   this.assigned_User_Roles
    // );


    /// jwt token generated
    const { ident_verify_secret, ...filterdata } = erpUser;
    var resp = await this.generateTokens(filterdata);
    this.jwtToken = resp['jwt'];

    //storing svm_jwt and erpUser into session storage
    sessionStorage.setItem('erpUser', JSON.stringify(filterdata));
    sessionStorage.setItem('svm_jwt', JSON.stringify(this.jwtToken));
    console.log(this.router.url);

    // veryfy tokens
    // var a = resp;
    // var resp1 = await this.verfiyTokens(a);
    // console.log(resp1);
    // if (this.urlPassReturnfpath == undefined || null || '') {
    //   this.router.navigate(['./' + this.fpath]);
    // } else {
    //   this.router.navigate(['./' + this.urlPassReturnfpath]);
    // }

    if (this.urlPassReturnfpath == undefined || this.urlPassReturnfpath == null) {


      await this.getHostFpath()
      console.log(this.fpath)
      if (erpUser && erpUser.b_acct_id) {

        this.fpath = this.fpath_withAcct;
      } else {
        // If b_acct_id is null or undefined

      }
      this.zone.run(() => {
        this.router.navigate(['./' + this.fpath])

      });

    }
    else {
      this.zone.run(() => {
        this.router.navigate(['./' + this.urlPassReturnfpath]);
      });

    }


  }
  getDecodedAccessToken(token: string) {
    console.log(token);

    return jwt_decode(token);

  }







  ////////////////////////////////////////////
  async getAllCurrentAccoutns() {
    const resp = await this.http
      .get<any>(this.httpUrl + '/systemdata/legalentity/getcurrentAccounts')
      .toPromise()
      .then((res) => {
        return res;
      });
    //console.log(resp)
    return resp;
  }
  async loginERP(obj: any) {
    const resp = await this.http
      .post<any>(this.httpUrl + '/systemdata/authentication/login', obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;
  }
  // async Gentoken(data:any) {
  // const resp = await this.http.post<any>(this.httpUrl + '/systemdata/authloginjwt/generateToken', data).toPromise().then(res => {
  //   return res;

  //   });
  // return resp;

  async generateTokens(data: any) {
    const resp = await this.http
      .post<any>(this.httpUrl + '/jwt/generateTokens', data)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;
  }
  async verfiyTokens(obj: any) {
    const resp = await this.http
      .post<any>(this.httpUrl + '/jwt/VerifyTokens', obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;
  }

  async getresourcebyrolecd(obj: any) {
    const resp = await this.http
      .get<any>(this.httpUrl + '/admin/resource/getresourcebyrolecd' + obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;
  }
  async getaccountmodule(obj: any) {
    const resp = await this.http
      .get<any>(this.httpUrl + '/systemdata/legalentity/getaccountmodule' + obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;
  }
  async getAllAssignedComponents(acct_id: any) {
    const resp = await this.http
      .get<any>(this.httpUrl + '/md/resource/getresourcebyrolecd' + acct_id)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;
  }

  async getCurrentUserFromAdmin(obj: any) {
    const resp = await this.http
      .get<any>(this.httpUrl + '/admin/user/getcurrentuser' + obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;
  }
  async createloginInfo(obj: any) {
    const resp = await this.http
      .post<any>(this.httpUrl + '/systemdata/loginInfo/createloginInfo', obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;
  }

  async getCurrentUserFromMD(obj: any) {
    const resp = await this.http
      .get<any>(this.httpUrl + '/md/user/getcurrentuser' + obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;
  }
  async sendMsg(mobile: any) {
    // var str = "https://2factor.in/API/V1/f5b33455-838a-11ea-9fa5-0200cd936042/SMS/" + mobile + "/" + otp + "/ERPUPDA"
    var str =
      'https://2factor.in/API/V1/' +
      this.api_key +
      '/SMS/' +
      mobile +
      '/AUTOGEN';
    const resp = await this.http
      .get<any>(str)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;
  }

  api_key = 'c6504fdd-0ca9-11ed-9c12-0200cd936042';
  async verifyMsg(otp_entered_by_user: any, session_id: any) {
    var str =
      'https://2factor.in/API/V1/' +
      this.api_key +
      '/SMS/VERIFY/' +
      session_id +
      '/' +
      otp_entered_by_user;
    const resp = await this.http
      .get<any>(str)
      .toPromise()
      .then((res) => {
        return true;
      })
      .catch((err) => {
        return false;
      });
    return resp;
  }
  async getAllAccounts(obj) {
    const resp = await this.http
      .post<any>(this.httpUrl + '/svm_auth/getAuthorisedListFor/acct', obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;

  }

  sol_cd = 'ERP'
  acct_id = 91

  //////////////////////////////////////////////
  async getAllroles(obj) {
    const resp = await this.http
      .post<any>(this.httpUrl + '/svm_auth/getAuthorisedListFor/roles', obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;

  }
  async getAllmodules(obj) {
    const resp = await this.http
      .post<any>(this.httpUrl + '/svm_auth/getAuthorisedListFor/mod', obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;

  }

  async getAllComponents(obj) {
    const resp = await this.http
      .post<any>(this.httpUrl + '/svm_auth/getAuthorisedListFor/comp', obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;

  }

  async getAllSolution(obj) {
    const resp = await this.http
      .post<any>(this.httpUrl + '/svm_auth/getAuthorisedListFor/sol', obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;

  }

  async isAuthorisedforcomp(obj) {
    const resp = await this.http
      .post<any>(this.httpUrl + '/svm_auth/isAuthorisedFor/comp', obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;

  }

  async isAuthorisedforacct(obj) {
    const resp = await this.http
      .post<any>(this.httpUrl + '/svm_auth/isAuthorisedFor/acct', obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;

  }

  async getAllrolesbysoln(obj) {
    const resp = await this.http
      .post<any>(this.httpUrl + '/svm_auth/getAuthorisedListFor/rolesbysoln', obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;

  }

  async isrolebysoln(obj) {
    const resp = await this.http
      .post<any>(this.httpUrl + '/svm_auth/getAuthorisedListFor/isrolebysoln', obj)
      .toPromise()
      .then((res) => {
        return res;
      });
    return resp;

  }
  ///////////////////////////////////REGISTRATION SERVICES//////////////////////////////////

  async register(obj) {
    const resp = this.http.post<any>(this.httpUrl + '/interface/property/auction/addparty', obj).toPromise().then(res => {
      //console.log(res)
      return res
    });
    return resp
  }
  getBillingAcctId() {
    return 1;
  }
  async createLegalEntity(obj) {
    const res = await this.http.post<any>(this.httpUrl + '/systemdata/legalentity/createindentity', obj).toPromise().then(res => {
      return res;
    });
    return res;

  }
  async changeUserPassword(obj) {

    const resp = await this.http.post<any>(this.httpUrl + '/systemdata/legalentity/updatepasswordauth', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }

  async sendmail(obj) {

    const resp = await this.http.post<any>(this.httpUrl + '/svm_auth/mailservice/sendemail', obj).toPromise().then(res => {
      return res;
    });
    return resp;
  }
  async getSubscription(obj) {
    const resp = await this.http.post<any>(this.httpUrl + '/svm_auth/getAuthorisedListFor/addSubscription', obj).toPromise().then(res => {
      return res;
    });
    return resp;

  }

  async isSubscribedfor(obj: any) {
    const resp = await this.http.post<any>(`${this.apiHost}:${this.apiPort}/svm_auth/getAuthorisedListFor/checkAccount`, obj).toPromise().then(res => {
      return res;
    });
    return resp;

  }

  async addSubscription(obj: any): Promise<any> {
    try {
      const resp = await this.http.post<any>(`${this.apiHost}:${this.apiPort}/svm_auth/getAuthorisedListFor/addSubscription`, obj).toPromise();
      return resp;
    } catch (error) {
      console.error('Error checking subscription:', error);
      throw error;
    }
  }

  async initAccount(obj: any): Promise<any> {
    try {
      const resp = await this.http.post<any>(`${this.apiHostDd}:${this.apiPortDd}/dd`, obj).toPromise();
      return resp;
    } catch (error) {
      console.error('Error creating Account:', error);
      throw error;
    }
  }




}